module.exports = __webpack_public_path__ + "static/media/file-excel.2a5528dc.svg";